<template>
  <b-autocomplete
    ref="autocomplete"
    v-model="search"
    :data="filteredData"
    :loading="isFetching"
    :field="field"
    @select="selectOption"
  />
</template>

<script>
export default {
  props: {
    model: {
      type: String,
      required: true
    },
    preselect: {
      type: Number,
      default: null
    },
    field: {
      type: String,
      default: "name"
    }
  },
  data() {
    return {
      data: [],
      search: "",
      selected: null,
      isFetching: false
    }
  },
  computed: {
    filteredData() {
      if (this.search.length > 2) {
        return this.data.filter(option => {
          return (
            option.name
              .toString()
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0
          )
        })
      } else {
        return []
      }
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    async fetch() {
      this.data = []
      this.isFetching = true

      try {
        // TODO: move this somewhere else
        let response = await this.$http.get(
          `${process.env.VUE_APP_API_LOCATION}/${this.model}/`
        )
        if (response.data.results) {
          response.data.results.forEach(item => this.data.push(item))
        } else {
          response.data.forEach(item => this.data.push(item))
        }

        if (this.preselect) {
          this.selected = this.data.find(item => item.id == this.preselect)
          this.$refs.autocomplete.setSelected(this.selected)
        }

        this.isFetching = false
      } catch (error) {
        this.isFetching = false
        throw error
      }
    },
    selectOption(option) {
      this.selected = option
      let id = option ? option.id : null
      this.$emit("select", id)
    }
  }
}
</script>
